import { Navigate, useLocation } from 'react-router';

/*
 * Links the backend puts into notifications (push, Telegram, the inbox) use
 * the cabinet's old addresses — /cabinet/crm/leads/12 and so on. The cabinet
 * lives at /dashboard, so these used to open the 404 page. Old notifications
 * keep their links forever, hence a redirect here rather than only a backend fix.
 */
export function appPath(url: string): string {
  const m = url.match(/^\/cabinet\/crm\/leads\/(\d+)/);
  if (m) return `/dashboard/leads?lead=${m[1]}`;
  if (/^\/cabinet\/crm\/calendar/.test(url)) return '/dashboard/calendar';
  if (/^\/cabinet\/crm\/(leads|clients)/.test(url)) return '/dashboard/leads';
  if (/^\/cabinet\/reviews/.test(url)) return '/dashboard/reviews';
  const obj = url.match(/^\/cabinet\/agency\/inventory\/(\d+)/);
  if (obj) return `/dashboard/agency/base?object=${obj[1]}`;
  if (/^\/cabinet\/agency\/(inventory|approvals)/.test(url)) return '/dashboard/agency/base';
  if (/^\/cabinet(\/|$)/.test(url)) return '/dashboard';
  return url;
}

/** Route element for /cabinet/* — forwards to the matching /dashboard page. */
export function LegacyCabinetRedirect() {
  const { pathname, search } = useLocation();
  return <Navigate to={appPath(pathname) + (appPath(pathname).includes('?') ? '' : search)} replace />;
}
